// extracted by mini-css-extract-plugin
export default {"container":"QPJZCw","icon":"lHi5_f","mobile":"QaPfbT"};